export const SpinnerMethods = {

	/*
	**  Set the methods
	*/

	methods: {

		showSpinner: function() {

			$('.spinnerWrap').css('display', 'flex');

		},

		hideSpinner: function() {

			$('.spinnerWrap').hide();

		}

	}

}